import styled from "styled-components"

const Style = styled.div`
  position: absolute;
  display: flex;
  gap: 12px;
  background: #FFFFFF;
  border-radius: 3px;
  padding: 0px var(--size);
  box-shadow: rgb(174, 174, 174) 0px 0px 10px;
  z-index: 2;
`;

export default function Tooltip({ mouseX = 0, mouseY = 0, children = null }) {
  return (
    <Style style={{ top: mouseY, left: mouseX }}>
      {children}
    </Style>
  )
}

